import { createAction } from '@reduxjs/toolkit';

import type {
  CreateTopicPayload,
  UpdateTopicPayload,
} from '@polyai/stream/commands/handlers/knowledge-base';
import type { ImportTopicsPayload } from '@polyai/stream/commands/handlers/knowledge-base/import-topics/schema';
import type { KnowledgeBaseDeleteTopic } from '@polyai/stream/protobuf/knowledge_base';

const PREFIX = 'knowledgeBase';

const createTopic = createAction<CreateTopicPayload>(`${PREFIX}/createTopic`);

const updateTopic = createAction<UpdateTopicPayload>(`${PREFIX}/updateTopic`);

const deleteTopic = createAction<KnowledgeBaseDeleteTopic>(
  `${PREFIX}/deleteTopic`,
);

const toggleTopicStatus = createAction<{ id: string; isActive: boolean }>(
  `${PREFIX}/toggleTopicStatus`,
);

const importTopics = createAction<ImportTopicsPayload>(
  `${PREFIX}/importTopics`,
);

export {
  createTopic,
  deleteTopic,
  importTopics,
  toggleTopicStatus,
  updateTopic,
};
